<div *ngIf="showTabs" class="col-md-12 colpadding0" style="margin-top: -9px; margin-left: -27px; ">
  <header class="panel-heading tab-bg-primary"
    style="background: none !important; margin-left: 33px; padding: 0px 0px; zoom: 0.9;">
    <ul class="nav nav-tabs" style="margin-left: -23px;">
      <li *ngFor="let item of mockTabs" class="listItem pemt" 
          (click)="navigateToMock(item.component)" style="margin-left: -8px !important"
          [ngClass]="{'selected-tab': isTabSelectedMock(item.component)}"
      >
        <a class="tabs">{{ item.tab }}</a>
      </li>
    </ul>
  </header>
</div>
 